import './App.css';
import './data/tasks.js';
import { Table } from './components/Table';
import { DataService } from './dataService';
import React from 'react';
import { OptionsPanel } from './components/OptionsPanel';
const dataService = new DataService();
function getCombatLevel(skills){
  let cmbLvl = Math.floor(skills.Prayer/2);
  cmbLvl = (cmbLvl + skills.Hitpoints + skills.Defence)/4;
  const meleeLvl = (skills.Strength + skills.Attack) * 0.325;
  const largestMageRange = Math.max(skills.Ranged, skills.Magic);
  const mageRangeLvl = (Math.floor(largestMageRange/2) + largestMageRange) *0.325;
  return cmbLvl + Math.max(meleeLvl, mageRangeLvl);
}
function App() {
  var [tab, setTab] = React.useState('all');
  var [allTasks, setAllTasks] = React.useState(dataService.getTasks());
  var [leagueTasks, setLeagueTasks] = React.useState([]);
  var [levels, setLevels] = React.useState({});
  var [selectedAreas, setSelectedAreas] = React.useState(dataService.getUnlockedAreas());
  var [useDarkMode, setUseDarkMode] = React.useState(dataService.getDarkMode());
  var [showOptions, setShowOptions] = React.useState(false);
  var [filters, setFilters] = React.useState(dataService.getFilters());
  var [ord, setOrd] = React.useState(dataService.getOrd());
  const personalChange = (task) => {
    dataService.togglePersonalTask(task);
    var allTasksCopy = [...allTasks];
    var updatedTask = {...allTasksCopy.find(x => x.id === task.id)};
    updatedTask.personal = !updatedTask.personal;
    setAllTasks(allTasksCopy);
  }
  var username = dataService.getUsername();
  React.useEffect(() => {
    if(username){
      fetch(wikisyncUrl.replace("{0}", username)).then(x => x.json())
        .then(x => {
          setLeagueTasks(x?.league_tasks || [])
          if(x.levels){
            x.levels["Combat level"] = getCombatLevel(x.levels);
          }
          
          setLevels(x?.levels || {});
        });
    }
  }, [])
  const completeChange = (task) => {
    dataService.toggleCompleteTask(task);
    var allTasksCopy = [...allTasks];
    var updatedTask = {...allTasksCopy.find(x => x.id === task.id)};
    updatedTask.complete = !updatedTask.complete;
    setAllTasks(allTasksCopy);
  }
  const wikisyncUrl = 'https://sync.runescape.wiki/runelite/player/{0}/TRAILBLAZER_RELOADED_LEAGUE';
  
  const personalTasks = allTasks.filter(x => !!x.personal);
  const updateUsername = (value) => {
    var url = wikisyncUrl.replace("{0}", encodeURIComponent(value));
    dataService.setUsername(value);
    fetch(url).then(res => res.json())
    .then(x => {
      setLeagueTasks(x?.league_tasks || [])
      if(x.levels){
        x.levels["Combat level"] = getCombatLevel(x.levels);
      }
      setLevels(x?.levels || {});
    });
  }
  const updateDarkMode = (value) => {
    dataService.setDarkMode(value);
    setUseDarkMode(value);
  }
  const updateUnlockedAreas = (value) => {
    dataService.setUnlockedAreas(value);
    setSelectedAreas(value);
  }
  const updateWikiSync = () => {
    if(username){
      fetch(wikisyncUrl.replace("{0}", username)).then(x => x.json())
        .then(x => {
          setLeagueTasks(x?.league_tasks || [])
          if(x.levels){
            x.levels["Combat level"] = getCombatLevel(x.levels);
          }
          
          setLevels(x?.levels || {});
        });
    }
  }
  const defaultUnlocks = [
    "Misthalin",
    "Karamja",
    "Global"
  ];
  const tableProps = {
    filter: filters,
    filterChange: (f) => {
      setFilters(f);
      dataService.setFilters(f);
    },
    ord: ord,
    ordChange: (f) => {
      setOrd(f);
      dataService.setOrd(f);
    },
    personalChange,
    completeChange,
    playerTasks: leagueTasks,
    unlockedAreas: [...selectedAreas, ...defaultUnlocks],
    levels
  }
  var element = tab == 'all'
    ? <Table tasks={allTasks} {...tableProps}/>
    : <Table tasks={personalTasks} {...tableProps}/>
  const className = "App" + (useDarkMode ? ' dark' : '');
  return (
    <div className={className}>
      <header style={{display: 'flex', justifyContent: 'space-between'}}>
        <h1>{tab == 'all' ? "Full task list" : "Personal task list"}</h1>
        <div style={{display: 'flex'}}>
          <button onClick={() => setTab(tab == 'all' ? 'personal' : 'all')} className="btn btn-primary btn-sm" style={{height: '30px'}}>{tab == 'all' ? 'Personal (' + personalTasks.length + ') >' : 'Full >'}</button>
          <i className="bi-gear" data-toggle="modal" data-target="#settings-modal" style={{fontSize: "32px", marginTop: "-14px", marginLeft: "8px", cursor: 'pointer'}} title="Settings"></i>
          <i className="bi-arrow-repeat"  style={{fontSize: "32px", marginTop: "-14px", marginLeft: "8px", cursor: 'pointer'}} title="WikiSync" onClick={() => updateWikiSync()}></i>
          <a href="https://discord.gg/RwhEHT9qhW" style={{marginTop: "-12px", marginLeft: "8px"}} target="_blank"><i className="bi-discord" style={{fontSize: "32px"}} title="Discord"></i></a>
        </div>
      </header>
      <div className="top-panel" style={{display: "flex", justifyContent: "space-between"}}>
        
        
        <div className="modal" tabIndex="-1" role="dialog" id="settings-modal">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Settings</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
                <OptionsPanel value={{
                  darkMode: useDarkMode,
                  unlockedAreas: selectedAreas,
                  username: username
                }}
                onChange={(val, key) => {
                  if(key === 'username'){
                    updateUsername(val.username);
                  }
                  if(key === 'darkMode'){
                    updateDarkMode(val.darkMode)
                  }
                  if(key === 'unlockedAreas'){
                    updateUnlockedAreas(val.unlockedAreas)
                  }
                }}/>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
      </div>
      {element}
    </div>
  );
}

export default App;
